module.exports = "### Download Complete\n\n- React is pretty awesome\n\n- Keeps getting better (v16 finally out)\n\n- Presentation built in React"


//////////////////
// WEBPACK FOOTER
// ./src/slides/13_thanks/notes_1.md
// module id = 1541
// module chunks = 0